<template>
  <div id="js-pro-d-view">
    <div v-if="assessment">
      <pro-d-grid-view :areas="assessment.areas"></pro-d-grid-view>
      <pro-d-rank-view :numbers="idsSortedByRank()"></pro-d-rank-view>
    </div>
    <v-container v-else>
      <v-row class="d-flex justify-center">
        <span class="assessment-text assessment-description">
          The Pro-D converges an individual’s key missions, competencies and
          styles. Although specifically focused on work style and roles, the
          Pro-D provides valuable insight into many facets of life in a
          practical and meaningful way.
        </span>
      </v-row>

      <v-row class="d-flex justify-center">
        <span class="assessment-text assessment-mentor-message">
          Your Mentor will work with you on when to take this assessment!
        </span>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import ProDGridView from "@/components/assessments/ProDGridView"
import ProDRankView from "@/components/assessments/ProDRankView"
import titleMixin from "@/mixins/titleMixin"

import User from "@/lib/user"
import { mapGetters } from "vuex"

export default {
  mixins: [titleMixin],
  components: { ProDGridView, ProDRankView },
  data: function() {
    return {
      title: "Work Style",
      userId: User.getUserId(),
      assessment: { areas: [] }
    }
  },
  created() {
    this.assessment = this.getAssessmentByType("Pro-D")
  },
  methods: {
    getAssessmentByType(type) {
      return this.assessments
        ? this.assessments.find(el => el.type == type)
        : {}
    },
    byRank(a, b) {
      if (a.rank < b.rank) {
        return -1
      }
      if (a.rank > b.rank) {
        return 1
      }
      return 0
    },
    idsSortedByRank() {
      let areas =
        this.assessment && this.assessment.areas ? this.assessment.areas : []
      let ranks = areas.map(el => {
        return {
          rank: parseInt(el.rank),
          id: parseInt(el.name.split("_")[0])
        }
      })
      return ranks.sort(this.byRank).map(el => el.id)
    }
  },
  computed: {
    ...mapGetters("assessments", ["getAssessmentsByUserId"]),
    assessments() {
      if (this.getAssessmentsByUserId(this.userId)) {
        return this.getAssessmentsByUserId(this.userId).assessments
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../scss/variables";
@import "../../scss/assessment-text";
</style>
